var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    "aria-label": "Shopify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17v-4.5a7 7 0 0 1 14 0V17",
    fill: "none",
    stroke: "#5E8E3E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H36A2.5 2.5 0 0 1 38.4 16.9L41 40.2A5 5 0 0 1 36 45H12A5 5 0 0 1 7 40.2L9.6 16.9A2.5 2.5 0 0 1 12 14Z",
    fill: "#95BF47"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 38,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 700,
    fill: "#ffffff"
  }, "S")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.15add512531b23f00b78d3f6a8827d26.svg";
export { ForwardRef as ReactComponent };